export default {
  invoices: [], // array of objects with some details for each invoice
  selectedInvoices: [],
  addAnotherInvoice: false,
  submitAllInvoices: false
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/batch-settings.js